module.exports = __webpack_public_path__ + "img/symbol-lens-signature-ko.e060828b.svg";